import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Loading = styled.div`
  pointer-events: all;
  user-select: none;
  position: fixed;
  width: 1920px;
  height: 1080px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  gap: 18px;
  background-color: var(--app-bg-color, #141414);
  /* Bleed the backdrop past the 1920×1080 box so it fills the whole window
     (the letterbox area), keeping the centered spinner in place. */
  box-shadow: 0 0 0 10000px var(--app-bg-color, #141414);
  z-index: 1000000;
  opacity: 1;
  transition: all 1s ease-in-out;

  &.off {
    pointer-events: none;
    opacity: 0;
  }
`;

// CSS loading icon: a ring in the app font color with a gap that spins.
export const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 3px solid var(--app-font-color, #ffffff);
  border-top-color: transparent;
  opacity: 0.9;
  animation: ${spin} 0.9s linear infinite;
`;

// Thin progress track. `currentColor` is the app font color (set on the track),
// so the dimmed rail and the fill stay in sync with the configured theme.
export const Progress = styled.div`
  position: relative;
  width: 140px;
  height: 2px;
  border-radius: 2px;
  overflow: hidden;
  color: var(--app-font-color, #ffffff);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: currentColor;
    opacity: 0.2;
  }
`;

// Width comes in as an inline style so a moving value doesn't mint a new class.
export const ProgressFill = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background-color: currentColor;
  opacity: 0.9;
  transition: width 0.35s ease-out;
`;

export const LoadingText = styled.div`
  color: var(--app-font-color, #ffffff);
  font-family: var(--app-font-family-secondary, "Space Mono", monospace);
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-align: center;
`;
